import { render, staticRenderFns } from "./contentUserDelete.vue?vue&type=template&id=1cb50d2e&"
import script from "./contentUserDelete.vue?vue&type=script&lang=js&"
export * from "./contentUserDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports